import { Ciudad } from './ciudad';

export class CiudadesRespuesta {
    public codret: string;
    public descret: string;
    public resultado: Ciudad[];
}